/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetWellKnownEmailServices200ResponseInnerConfig } from './GetWellKnownEmailServices200ResponseInnerConfig';
import {
    GetWellKnownEmailServices200ResponseInnerConfigFromJSON,
    GetWellKnownEmailServices200ResponseInnerConfigFromJSONTyped,
    GetWellKnownEmailServices200ResponseInnerConfigToJSON,
    GetWellKnownEmailServices200ResponseInnerConfigToJSONTyped,
} from './GetWellKnownEmailServices200ResponseInnerConfig';

/**
 * 
 * @export
 * @interface GetWellKnownEmailServices200ResponseInner
 */
export interface GetWellKnownEmailServices200ResponseInner {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    displayName?: string;
    /**
     * 
     */
    config?: GetWellKnownEmailServices200ResponseInnerConfig;
}

/**
 * Check if a given object implements the GetWellKnownEmailServices200ResponseInner interface.
 */
export function instanceOfGetWellKnownEmailServices200ResponseInner(value: object): value is GetWellKnownEmailServices200ResponseInner {
    return true;
}

export function GetWellKnownEmailServices200ResponseInnerFromJSON(json: any): GetWellKnownEmailServices200ResponseInner {
    return GetWellKnownEmailServices200ResponseInnerFromJSONTyped(json, false);
}

export function GetWellKnownEmailServices200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWellKnownEmailServices200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'config': json['config'] == null ? undefined : GetWellKnownEmailServices200ResponseInnerConfigFromJSON(json['config']),
    };
}

export function GetWellKnownEmailServices200ResponseInnerToJSON(json: any): GetWellKnownEmailServices200ResponseInner {
    return GetWellKnownEmailServices200ResponseInnerToJSONTyped(json, false);
}

export function GetWellKnownEmailServices200ResponseInnerToJSONTyped(value?: GetWellKnownEmailServices200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'config': GetWellKnownEmailServices200ResponseInnerConfigToJSON(value['config']),
    };
}

